import Router from 'next/router';
import URL from '@/creditflowresearch/Router/urlConstants';
import Product from '@/creditflowresearch/domain/Product';
import Region from '@/creditflowresearch/domain/Region';
import { isValidSectorIndustry } from '@/creditflowresearch/application/actions/profile/helpers/isValidSectorIndustry';
import { collectBaseFiltersData } from './collectBaseFiltersData';
import { getFiltersByPairs } from '@/creditflowresearch/application/actions/profile/helpers/getFiltersByPairs';
import { IBaseProfileFiltersConfig } from './types';

interface IBaseFilters {
  getChartBy: string,
  getDealsBy: string,
  getTopCompaniesBy: string,
  isConsumerOverview: boolean,
  isOverview: boolean,
  productIds: string[],
  regionIds: string[],
  industry: Record<string, any> | null,
  sector: Record<string, any> | null,
  sectorBlock: boolean,
  skipNextUpdate: IBaseProfileFiltersConfig['skipNextUpdate'],
}

export const getBaseProfileFilters = ({ ...config }: IBaseProfileFiltersConfig): IBaseFilters => {
  const { profileType, headerData } = config;

  const {
    validProducts,
    validRegions,
    industry,
    sector,
    isConsumerOverview,
    skipNextUpdate,
  } = collectBaseFiltersData({ ...config });

  let filters = {
    productIds: Product.getIds(validProducts),
    regionIds: Region.getIds(validRegions),
    sector: null,
    industry: null,
    isOverview: (!industry && !sector),
    isConsumerOverview,
    skipNextUpdate,
  };

  if (sector) {
    if (!isValidSectorIndustry(headerData.sectorsList, sector)) {
      Router.push(URL.NOT_FOUND);
      return null;
    }

    filters = {
      ...filters,
      sector: headerData.sectorsList[sector],
    };
  }

  if (industry) {
    if (!isValidSectorIndustry(headerData.industriesList, industry)) {
      Router.push(URL.NOT_FOUND);
      return null;
    }

    filters = {
      ...filters,
      industry: headerData.industriesList[industry],
    };
  }

  const profileFilters = getFiltersByPairs({
    mapping: headerData.mapping,
    profileType,
    selectedProducts: filters.productIds,
    selectedRegions: filters.regionIds,
  });

  return {
    ...filters,
    ...profileFilters,
  };
};
